import { getAuthTokenAsync } from "src/store/common";
import * as api from "./api";



export const fetchBookingList = async (data: {
  page: number;
  limit: number;
}) => {
  const params: any = {
    page: data.page,
    limit: data.limit,
  };

  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/booking`,
    params,
  );
  return response;
};

// fetch user list
export const fetchRevenueList = async (data: {
  page: number;
  limit: number;
}) => {
  const params: any = {
    page: data.page,
    limit: data.limit,
  };

  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/revenue/bookings`,
    params,
  );
  return response;
};
